'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SailthruInit = function (_PureComponent) {
    (0, _inherits3.default)(SailthruInit, _PureComponent);

    function SailthruInit() {
        (0, _classCallCheck3.default)(this, SailthruInit);
        return (0, _possibleConstructorReturn3.default)(this, (SailthruInit.__proto__ || (0, _getPrototypeOf2.default)(SailthruInit)).apply(this, arguments));
    }

    (0, _createClass3.default)(SailthruInit, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (window.Sailthru && window.Sailthru.init && !window.Sailthru.initRan) {
                window.Sailthru.init({
                    autoTrackPageview: false,
                    customerId: this.props.customerId,
                    isCustom: true,
                    useStoredTags: true
                });
                window.Sailthru.initRan = true;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return SailthruInit;
}(_react.PureComponent);

exports.default = SailthruInit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Sailthru/SailthruInit.js
// module id = FlQW
// module chunks = 60